webpackJsonp([73951219910528],{

/***/ 774:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/signs-of-spring/"},"excerpt":"Everyone knows spring has arrived when the trees are in bloom and they hear the chirping of birds that have been absent all winter…","timeToRead":1,"frontmatter":{"title":"Signs of Spring","tags":["birds","blossoms","spring"]}}}]}},"pathContext":{"tag":"spring"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-spring-edad0ea73cee2ee18727.js